
// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Button,
//   useTheme,
//   useMediaQuery,
//   Pagination
// } from '@mui/material';
// import { Link, useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import Loader from '../../../Loader/Loader'; // Import your custom Loader component

// const NewlyView = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery(theme.breakpoints.down('md'));
//   const navigate = useNavigate();

//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Get user data from Redux store for recording views
//   const isLoggedIn = useSelector(state => state.user.isAuthenticated);
//   const userData = useSelector(state => state.user.user);

//   // Pagination states
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(0);
//   const [totalProperties, setTotalProperties] = useState(0);
//   const itemsPerPage = 10; // ✅ Changed to 10 items per page

//   useEffect(() => {
//     const fetchProperties = async () => {
//       try {
//         setLoading(true);

//         // ✅ Using 10 items per page
//         const response = await fetch(`https://propertydealstalk.com/api/property/getNewestProperties?page=${page}&limit=${itemsPerPage}`);
//         const data = await response.json();

//         console.log('API Response:', data); // ✅ Debug log

//         if (data.status === "SUCCESS" && data.result && data.result.properties) {
//           const fetchedProperties = data.result.properties;

//           // ✅ Debug: Log each property's price data
//           fetchedProperties.forEach((prop, index) => {
//             console.log(`Property ${index + 1}:`, {
//               id: prop.id,
//               name: prop.property_name,
//               asking_price: prop.asking_price,
//               monthly_rent: prop.monthly_rent,
//               commercial_catgory: prop.commercial_catgory,
//               currency: prop.currency
//             });
//           });

//           setProperties(fetchedProperties);

//           // If the API provides total count, use it to calculate total pages
//           if (data.result.totalCount) {
//             setTotalProperties(data.result.totalCount);
//             setTotalPages(Math.ceil(data.result.totalCount / itemsPerPage));
//           } else {
//             // If no total count is provided, just use the current properties length
//             setTotalPages(Math.ceil(data.result.properties.length / itemsPerPage));
//           }
//         } else {
//           setError('Failed to fetch property data');
//         }
//       } catch (error) {
//         console.error("Error fetching properties:", error);
//         setError('Error fetching properties. Please try again later.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProperties();
//   }, [page]); // Fetch new data when page changes

//   // Function to record property view
//   const recordPropertyView = async (propertyId) => {
//     if (!isLoggedIn || !userData) {
//       console.log('User not logged in, skipping view recording');
//       return;
//     }

//     try {
//       // Get the user_id from userData
//       const userId = userData.id;

//       if (!userId) {
//         console.error('User ID not found in user data');
//         return;
//       }

//       console.log('Recording property view with user_id:', userId, 'property_id:', propertyId);

//       const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: userId,
//           property_id: propertyId
//         }),
//       });

//       const data = await response.json();

//       if (data.statusCode === 200) {
//         console.log('Property view recorded successfully:', data.result);
//       } else {
//         console.error('Failed to record property view:', data.message);
//       }
//     } catch (err) {
//       console.error('Error recording property view:', err);
//     }
//   };

//   // Function to handle page change
//   const handlePageChange = (event, value) => {
//     setPage(value);
//     // Scroll to top when changing pages
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   // Handle property card click - navigate to property detail page
//   const handlePropertyClick = (propertyId) => {
//     // Record the property view
//     recordPropertyView(propertyId);
//     // Navigate to the property details page
//     navigate(`/view/${propertyId}`);
//   };

//   // ✅ Function to check if image has valid data
//   const hasValidImage = (base64) => {
//     return base64 && base64.length > 100;
//   };

//   // ✅ Function to format price with Indian numbering system (lakhs format)
//   const formatPrice = (price) => {
//     if (!price || price === 0 || price === '0') return '';
    
//     const priceStr = price.toString();
//     const lastThree = priceStr.substring(priceStr.length - 3);
//     const otherNumbers = priceStr.substring(0, priceStr.length - 3);
    
//     if (otherNumbers !== '') {
//       return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
//     }
    
//     return lastThree;
//   };

//   // ✅ NEW: Function to format time ago (like "2w ago")
//   const getTimeAgo = (dateString) => {
//     if (!dateString) return '';
    
//     const date = new Date(dateString);
//     const now = new Date();
//     const diffInSeconds = Math.floor((now - date) / 1000);
    
//     const intervals = {
//       y: 31536000,
//       mo: 2592000,
//       w: 604800,
//       d: 86400,
//       h: 3600,
//       m: 60,
//       s: 1
//     };
    
//     for (const [key, value] of Object.entries(intervals)) {
//       const interval = Math.floor(diffInSeconds / value);
//       if (interval >= 1) {
//         return `${interval}${key} ago`;
//       }
//     }
    
//     return 'just now';
//   };

//   // ✅ FIXED: Function to get display price - matches TalkView.jsx logic
//   const getDisplayPrice = (property) => {
//     console.log('Getting display price for:', property.property_name, {
//       commercial_catgory: property.commercial_catgory,
//       monthly_rent: property.monthly_rent,
//       asking_price: property.asking_price
//     });

//     // Check if this is a rental property (case-insensitive comparison)
//     const category = property.category || property.commercial_catgory || '';
//     const isRental = category.toLowerCase() === 'rent';

//     if (isRental) {
//       // For rental properties, prioritize monthly_rent
//       if (property.monthly_rent && property.monthly_rent !== 0 && property.monthly_rent !== '0') {
//         console.log('Rental price:', property.monthly_rent);
//         return property.monthly_rent;
//       }
//     }

//     // For sale properties or if monthly_rent is not available, use asking_price
//     if (property.asking_price && property.asking_price !== 0 && property.asking_price !== '0') {
//       console.log('Sale price:', property.asking_price);
//       return property.asking_price;
//     }

//     console.log('No valid price found');
//     return null; // Return null if no price is available
//   };

//   return (
//     <Box
//       component="section"
//       sx={{
//         padding: '40px 20px',
//         backgroundColor: '#fff',
//         fontFamily: 'Outfit',
//         textAlign: isMobile ? 'center' : 'left',
//       }}
//     >
//       {/* ✅ Custom Loading Effect */}
//       {loading && <Loader />}

//       <Box
//         className="newly-added-header"
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'flex-end',
//           paddingBottom: '20px',
//           flexDirection: isMobile ? 'column' : 'row',
//           textAlign: isMobile ? 'center' : 'left',
//         }}
//       >
//         <Box>
//           <Typography
//             variant="h2"
//             sx={{
//               fontSize: isMobile ? '24px' : '20px',
//               margin: 0,
//               color: '#000',
//               fontWeight: 500,
//             }}
//           >
//             Newly added Properties
//           </Typography>
//           <Typography
//             sx={{
//               marginTop: '4px',
//               fontSize: '14px',
//               color: '#626262',
//               fontWeight: 400,
//             }}
//           >
//             All New Listings
//           </Typography>
//         </Box>
//         <Box sx={{ mt: isMobile ? '10px' : 0 }}>
//           <Link
//             to="/"
//             style={{
//               textDecoration: 'none',
//               fontWeight: 500,
//               color: '#626262',
//             }}
//           >
//             Back to Home
//           </Link>
//         </Box>
//       </Box>

//       {error ? (
//         <Typography color="error" sx={{ textAlign: 'center' }}>
//           {error}
//         </Typography>
//       ) : properties.length === 0 && !loading ? (
//         <Typography sx={{ textAlign: 'center' }}>
//           No properties found
//         </Typography>
//       ) : !loading ? (
//         <>
//           <Box
//             className="properties-container"
//             sx={{
//               display: 'grid',
//               gridTemplateColumns: isMobile
//                 ? '1fr'
//                 : isTablet
//                 ? 'repeat(2, 1fr)'
//                 : 'repeat(4, 1fr)',
//               gap: '20px',
//               paddingBottom: '10px',
//             }}
//           >
//             {properties.map((prop, index) => {
//               const hasImage = hasValidImage(prop.image);
//               const displayPrice = getDisplayPrice(prop);
//               const isRental = (prop.category || prop.commercial_catgory || '').toLowerCase() === 'rent';
//               const timeAgo = getTimeAgo(prop.updatedAt || prop.createdAt);

//               return (
//                 <Box
//                   key={prop.id}
//                   className="new-card"
//                   sx={{
//                     borderRadius: '10px',
//                     overflow: 'hidden',
//                     transition: 'transform 0.3s ease',
//                     boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//                     cursor: 'pointer',
//                     '&:hover': {
//                       transform: 'translateY(-5px)',
//                     },
//                   }}
//                   onClick={() => handlePropertyClick(prop.id)}
//                 >
//                   {/* ✅ Image Container with Time Badge */}
//                   <Box sx={{ position: 'relative', width: '100%', height: '160px' }}>
//                     {hasImage ? (
//                       <Box
//                         component="img"
//                         src={`data:image/png;base64,${prop.image}`}
//                         alt={prop.property_name}
//                         sx={{
//                           width: '100%',
//                           height: '100%',
//                           objectFit: 'cover',
//                         }}
//                       />
//                     ) : (
//                       <Box
//                         sx={{
//                           width: '100%',
//                           height: '100%',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           backgroundColor: '#f5f5f5',
//                           border: '1px dashed #ccc'
//                         }}
//                       >
//                         <Typography variant="body2" color="#888" textAlign="center" px={2}>
//                           No images uploaded
//                         </Typography>
//                       </Box>
//                     )}

//                     {/* ✅ Time Ago Badge - Positioned at bottom-right */}
//                     {timeAgo && (
//                       <Box
//                         sx={{
//                           position: 'absolute',
//                           bottom: '8px',
//                           right: '8px',
//                           bgcolor: 'rgba(0, 0, 0, 0.7)',
//                           color: '#fff',
//                           px: '8px',
//                           py: '4px',
//                           borderRadius: '4px',
//                           fontSize: '11px',
//                           fontWeight: 500,
//                           zIndex: 2,
//                         }}
//                       >
//                         {timeAgo}
//                       </Box>
//                     )}
//                   </Box>

//                   <Box
//                     className="new-info"
//                     sx={{
//                       padding: '15px',
//                       textAlign: 'left',
//                     }}
//                   >
//                     <Typography
//                       className="desc"
//                       sx={{
//                         fontWeight: 500,
//                         fontSize: '16px',
//                         color: '#000',
//                       }}
//                     >
//                       {prop.property_name}
//                     </Typography>

//                     <Typography
//                       component="h3"
//                       sx={{
//                         fontSize: '16px',
//                         fontWeight: 400,
//                         margin: '5px 0',
//                         color: '#626262',
//                       }}
//                     >
//                       {prop.property_type ? prop.property_type.charAt(0).toUpperCase() + prop.property_type.slice(1) : 'N/A'}
//                     </Typography>

//                     <Typography
//                       sx={{
//                         fontSize: '12px',
//                         color: '#626262',
//                         margin: '3px 0',
//                         fontWeight: 400,
//                       }}
//                     >
//                       {prop.area_name}, {prop.location}
//                     </Typography>

//                     {/* ✅ FIXED: Display price with proper spacing and conditional rendering */}
//                     <Typography
//                       className="price"
//                       sx={{
//                         fontSize: '14px',
//                         fontWeight: 600,
//                         color: '#2563EB',
//                         fontStyle: 'normal',
//                         mt: 1,
//                         minHeight: '21px'
//                       }}
//                     >
//                       {displayPrice ? (
//                         <>
//                           {prop.currency || '₹'} {formatPrice(displayPrice)}
//                           {isRental && '/month'}
//                         </>
//                       ) : (
//                         'Price on Request'
//                       )}
//                     </Typography>

//                     <Button
//                       variant="outlined"
//                       sx={{
//                         marginTop: '10px',
//                         padding: '18px 56px',
//                         color: '#2563EB',
//                         borderColor: '#2563EB',
//                         borderRadius: '10px',
//                         textTransform: 'none',
//                         fontWeight: 500,
//                         fontStyle: 'normal',
//                       }}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handlePropertyClick(prop.id);
//                       }}
//                     >
//                       View Property
//                     </Button>
//                   </Box>
//                 </Box>
//               );
//             })}
//           </Box>

//           {/* ✅ Pagination component - Right aligned */}
//           {totalPages > 1 && (
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
//               <Pagination
//                 count={totalPages}
//                 page={page}
//                 onChange={handlePageChange}
//                 color="primary"
//                 size={isMobile ? "small" : "medium"}
//                 showFirstButton
//                 showLastButton
//                 sx={{
//                   '& .MuiPaginationItem-root': {
//                     color: '#333',
//                   },
//                   '& .Mui-selected': {
//                     backgroundColor: '#2563EB !important',
//                     color: 'white',
//                   }
//                 }}
//               />
//             </Box>
//           )}
//         </>
//       ) : null}
//     </Box>
//   );
// };

// export default NewlyView;


import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
  Pagination
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from '../../../Loader/Loader';

const NewlyView = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isLoggedIn = useSelector(state => state.user.isAuthenticated);
  const userData = useSelector(state => state.user.user);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalProperties, setTotalProperties] = useState(0);
  const itemsPerPage = 10;

  // Function to get user-friendly error message
  const getUserFriendlyErrorMessage = (error) => {
    const errorString = error.toString().toLowerCase();
    
    if (errorString.includes('fetch') || 
        errorString.includes('network') || 
        errorString.includes('failed to fetch') ||
        errorString.includes('networkerror') ||
        errorString.includes('connection')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('timeout')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('500') || errorString.includes('server error')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('404') || errorString.includes('not found')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    // Default generic message for any other error
    return 'Unable to load the properties. Please check your internet connection and try again.';
  };

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(`https://propertydealstalk.com/api/property/getNewestProperties?page=${page}&limit=${itemsPerPage}`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        console.log('API Response:', data);

        if (data.status === "SUCCESS" && data.result && data.result.properties) {
          const fetchedProperties = data.result.properties;

          fetchedProperties.forEach((prop, index) => {
            console.log(`Property ${index + 1}:`, {
              id: prop.id,
              name: prop.property_name,
              asking_price: prop.asking_price,
              monthly_rent: prop.monthly_rent,
              category: prop.category,
              currency: prop.currency
            });
          });

          setProperties(fetchedProperties);

          if (data.result.total) {
            setTotalProperties(data.result.total);
            setTotalPages(Math.ceil(data.result.total / itemsPerPage));
          } else {
            setTotalPages(Math.ceil(fetchedProperties.length / itemsPerPage));
          }
        } else {
          throw new Error('Unable to load properties');
        }
      } catch (error) {
        console.error("Error fetching properties:", error);
        const friendlyMessage = getUserFriendlyErrorMessage(error);
        setError(friendlyMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, [page]);

  const recordPropertyView = async (propertyId) => {
    if (!isLoggedIn || !userData) {
      return;
    }

    try {
      const userId = userData.id;
      if (!userId) {
        return;
      }

      const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          property_id: propertyId
        }),
      });

      const data = await response.json();
      if (data.statusCode === 200) {
        console.log('Property view recorded successfully');
      }
    } catch (err) {
      console.error('Error recording property view:', err);
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePropertyClick = (propertyId) => {
    recordPropertyView(propertyId);
    navigate(`/view/${propertyId}`);
  };

  const hasValidImage = (base64) => {
    return base64 && base64.length > 100;
  };

  const formatPrice = (price) => {
    if (!price || price === 0 || price === '0') return '';
    
    const priceStr = price.toString();
    const lastThree = priceStr.substring(priceStr.length - 3);
    const otherNumbers = priceStr.substring(0, priceStr.length - 3);
    
    if (otherNumbers !== '') {
      return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
    }
    
    return lastThree;
  };

  const getTimeAgo = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    const intervals = {
      y: 31536000,
      mo: 2592000,
      w: 604800,
      d: 86400,
      h: 3600,
      m: 60,
      s: 1
    };
    
    for (const [key, value] of Object.entries(intervals)) {
      const interval = Math.floor(diffInSeconds / value);
      if (interval >= 1) {
        return `${interval}${key} ago`;
      }
    }
    
    return 'just now';
  };

  const getDisplayPrice = (property) => {
    const category = property.category || '';
    const isRental = category.toLowerCase() === 'rent';

    if (isRental) {
      if (property.monthly_rent && property.monthly_rent !== 0 && property.monthly_rent !== '0') {
        return property.monthly_rent;
      }
    }

    if (property.asking_price && property.asking_price !== 0 && property.asking_price !== '0') {
      return property.asking_price;
    }

    return null;
  };

  return (
    <Box
      component="section"
      sx={{
        padding: '40px 20px',
        backgroundColor: '#fff',
        fontFamily: 'Outfit',
        textAlign: isMobile ? 'center' : 'left',
      }}
    >
      {loading && <Loader />}

      <Box
        className="newly-added-header"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          paddingBottom: '20px',
          flexDirection: isMobile ? 'column' : 'row',
          textAlign: isMobile ? 'center' : 'left',
        }}
      >
        <Box>
          <Typography
            variant="h2"
            sx={{
              fontSize: isMobile ? '24px' : '20px',
              margin: 0,
              color: '#000',
              fontWeight: 500,
            }}
          >
            Newly added Properties
          </Typography>
          <Typography
            sx={{
              marginTop: '4px',
              fontSize: '14px',
              color: '#626262',
              fontWeight: 400,
            }}
          >
            All New Listings
          </Typography>
        </Box>
        <Box sx={{ mt: isMobile ? '10px' : 0 }}>
          <Link
            to="/"
            style={{
              textDecoration: 'none',
              fontWeight: 500,
              color: '#626262',
            }}
          >
            Back to Home
          </Link>
        </Box>
      </Box>

      {error ? (
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            p: 4,
            textAlign: 'center',
            minHeight: '300px'
          }}
        >
          <Typography 
            sx={{ 
              color: '#666',
              fontSize: '1.1rem',
              fontWeight: 500,
              maxWidth: '600px'
            }}
          >
            {error}
          </Typography>
        </Box>
      ) : properties.length === 0 && !loading ? (
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            p: 4,
            textAlign: 'center',
            minHeight: '300px'
          }}
        >
          <Typography 
            sx={{ 
              color: '#666',
              fontSize: '1.1rem',
              fontWeight: 500
            }}
          >
            No properties found
          </Typography>
        </Box>
      ) : !loading ? (
        <>
          <Box
            className="properties-container"
            sx={{
              display: 'grid',
              gridTemplateColumns: isMobile
                ? '1fr'
                : isTablet
                ? 'repeat(2, 1fr)'
                : 'repeat(4, 1fr)',
              gap: '20px',
              paddingBottom: '10px',
            }}
          >
            {properties.map((prop) => {
              const hasImage = hasValidImage(prop.image);
              const displayPrice = getDisplayPrice(prop);
              const isRental = (prop.category || '').toLowerCase() === 'rent';
              const timeAgo = getTimeAgo(prop.createdAt);

              return (
                <Box
                  key={prop.id}
                  className="new-card"
                  sx={{
                    borderRadius: '10px',
                    overflow: 'hidden',
                    transition: 'transform 0.3s ease',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    cursor: 'pointer',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                    },
                  }}
                  onClick={() => handlePropertyClick(prop.id)}
                >
                  <Box sx={{ position: 'relative', width: '100%', height: '160px' }}>
                    {hasImage ? (
                      <Box
                        component="img"
                        src={`data:image/png;base64,${prop.image}`}
                        alt={prop.property_name}
                        sx={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f5f5f5',
                          border: '1px dashed #ccc'
                        }}
                      >
                        <Typography variant="body2" color="#888" textAlign="center" px={2}>
                          No images uploaded
                        </Typography>
                      </Box>
                    )}

                    {timeAgo && (
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: '8px',
                          right: '8px',
                          bgcolor: 'rgba(0, 0, 0, 0.7)',
                          color: '#fff',
                          px: '8px',
                          py: '4px',
                          borderRadius: '4px',
                          fontSize: '11px',
                          fontWeight: 500,
                          zIndex: 2,
                        }}
                      >
                        {timeAgo}
                      </Box>
                    )}
                  </Box>

                  <Box
                    className="new-info"
                    sx={{
                      padding: '15px',
                      textAlign: 'left',
                    }}
                  >
                    <Typography
                      className="desc"
                      sx={{
                        fontWeight: 500,
                        fontSize: '16px',
                        color: '#000',
                      }}
                    >
                      {prop.property_name}
                    </Typography>

                    <Typography
                      component="h3"
                      sx={{
                        fontSize: '16px',
                        fontWeight: 400,
                        margin: '5px 0',
                        color: '#626262',
                      }}
                    >
                      {prop.property_type ? prop.property_type.charAt(0).toUpperCase() + prop.property_type.slice(1) : 'N/A'}
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: '12px',
                        color: '#626262',
                        margin: '3px 0',
                        fontWeight: 400,
                      }}
                    >
                      {prop.area_name}, {prop.location}
                    </Typography>

                    <Typography
                      className="price"
                      sx={{
                        fontSize: '14px',
                        fontWeight: 600,
                        color: '#2563EB',
                        fontStyle: 'normal',
                        mt: 1,
                        minHeight: '21px'
                      }}
                    >
                      {displayPrice ? (
                        <>
                          {prop.currency || '₹'} {formatPrice(displayPrice)}
                          {isRental && '/month'}
                        </>
                      ) : (
                        'Price on Request'
                      )}
                    </Typography>

                    <Button
                      variant="outlined"
                      sx={{
                        marginTop: '10px',
                        padding: '18px 56px',
                        color: '#2563EB',
                        borderColor: '#2563EB',
                        borderRadius: '10px',
                        textTransform: 'none',
                        fontWeight: 500,
                        fontStyle: 'normal',
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePropertyClick(prop.id);
                      }}
                    >
                      View Property
                    </Button>
                  </Box>
                </Box>
              );
            })}
          </Box>

          {totalPages > 1 && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                size={isMobile ? "small" : "medium"}
                showFirstButton
                showLastButton
                sx={{
                  '& .MuiPaginationItem-root': {
                    color: '#333',
                  },
                  '& .Mui-selected': {
                    backgroundColor: '#2563EB !important',
                    color: 'white',
                  }
                }}
              />
            </Box>
          )}
        </>
      ) : null}
    </Box>
  );
};

export default NewlyView;
